export const marks4 = [
  {
    value: 0,
    label: "-",
  },
  {
    value: 1,
    label: "+",
  },
  {
    value: 2,
    label: "++",
  },
  {
    value: 3,
    label: "+++",
  },
];
export const marks2 = [
  {
    value: 0,
    label: "-",
  },
  {
    value: 1,
    label: "+",
  },
];
